// AUTO-GENERATED by js/brand/generate.mjs — do not edit.
// Regenerate with `pnpm run brand` from the repo root.

export type BrandStory = {
  tagline?: string;
  readingsIntro?: string;
  readings?: { title: string; body: string }[];
  geometry?: {
    grid: number;
    tilePath: string;
    markPath: string;
    upperPlay: number[][];
    lowerPlay: number[][];
    center: number[];
  };
  constructionNotes?: string;
  specs?: { label: string; value: string }[];
  usage?: { ok: boolean; text: string }[];
};

export type Brand = {
  name: string;
  slug: string;
  wordmark: string;
  defaultSiteTitle: string;
  monochrome: boolean;
  colors: {
    ink: string;
    paper: string;
    tileBackground: string;
    tileForeground: string;
    tileHairline: string;
  };
  markSvg: string;
  tileSvg: string;
  wordmarkSvg: string;
  assets: { file: string; label: string }[];
  story: BrandStory | null;
};

export const BRAND: Brand = {
  name: "Streamplace",
  slug: "streamplace",
  wordmark: "stream.place",
  defaultSiteTitle: "My Streamplace Node",
  monochrome: false,
  colors: {
    ink: "#0A0A0B",
    paper: "#ffffff",
    tileBackground: "#111113",
    tileForeground: "#ffffff",
    tileHairline: "rgba(255,255,255,0.10)",
  },
  markSvg: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -6.1 493.29 493.29\"><path d=\"m253.76 445.69-208.02-93.734-45.742-290.22 243.33-61.739 249.95 58.678-9.9427 310.8z\" fill=\"#f8baca\"/><path d=\"m253.59 481.09-241.31-105.15-12.277-314.2 253.59 70.875 239.69-73.936-85.842 261.91z\" fill=\"#de91a6\"/><path d=\"m493.29 58.678-239.7 73.933-0.59253 348.48 230.34-111.61z\" fill=\"#ac6e81\"/></svg>\n",
  tileSvg: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M 0 16 C 0 4 4 0 16 0 C 28 0 32 4 32 16 C 32 28 28 32 16 32 C 4 32 0 28 0 16 Z\" fill=\"#111113\"/><path d=\"M 0 16 C 0 4 4 0 16 0 C 28 0 32 4 32 16 C 32 28 28 32 16 32 C 4 32 0 28 0 16 Z\" fill=\"none\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\"/><g transform=\"translate(4 4.297) scale(0.049)\"><path d=\"m253.76 445.69-208.02-93.734-45.742-290.22 243.33-61.739 249.95 58.678-9.9427 310.8z\" fill=\"#f8baca\"/><path d=\"m253.59 481.09-241.31-105.15-12.277-314.2 253.59 70.875 239.69-73.936-85.842 261.91z\" fill=\"#de91a6\"/><path d=\"m493.29 58.678-239.7 73.933-0.59253 348.48 230.34-111.61z\" fill=\"#ac6e81\"/></g></svg>",
  wordmarkSvg: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 456 96\"><text x=\"0\" y=\"68\" fill=\"currentColor\" font-family=\"Geist, Inter, Arial, sans-serif\" font-size=\"72\" font-weight=\"600\" letter-spacing=\"-1.44\">stream.place</text></svg>",
  assets: [{"file":"streamplace-mark.svg","label":"Mark"},{"file":"streamplace-tile.svg","label":"App tile"},{"file":"streamplace-wordmark.svg","label":"Wordmark"},{"file":"streamplace-lockup.svg","label":"Lockup"}],
  story: null,
};
